import Repository from "../Repository";

const resource = "/product/positioning-seat";

export default {
  /**
   * Get positioning seat
   * @param {*} positioning_seat
   */
  async get(positioning_seat) {
    return Repository.get(`${resource}/${positioning_seat}`);
  },

  async createPositioningSeat(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
